import { render, staticRenderFns } from "./CheckinRule.vue?vue&type=template&id=6ce40e38"
import script from "./CheckinRule.vue?vue&type=script&lang=js"
export * from "./CheckinRule.vue?vue&type=script&lang=js"
import style0 from "./CheckinRule.vue?vue&type=style&index=0&id=6ce40e38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports